import loginAndSignup from "../../locales/fr/help/loginAndSignup.json";
import howToStart from "../../locales/fr/help/howToStart.json";
import createEndpoint from "../../locales/fr/help/createEndpoint.json";
import createProfile from "../../locales/fr/help/createProfile.json";
import aiEndpointOverview from "../../locales/fr/help/aiEndpointOverview.json";
import configureAIEndpoint from "../../locales/fr/help/configureAIEndpoint.json";
import testAIEndpoint from "../../locales/fr/help/testAIEndpoint.json";
import helpRgp from "../../locales/fr/help/helpRgp.json";
import helpPrompt from "../../locales/fr/help/helpPrompt.json";
import helpPromptInput from "../../locales/fr/help/helpPromptInput.json";
import AISimulatorGuide from "../../locales/fr/help/AISimulatorGuide.json";
import CreateEndpointUsingJsonParams from "../../locales/fr/help/CreateEndpointUsingJsonParams.json";
import CreateEndpointUsingScripts from "../../locales/fr/help/CreateEndpointUsingScripts.json";
import CreateEp from "../../locales/fr/help/CreateEp.json";
import DeleteEndpoint from "../../locales/fr/help/DeleteEndpoint.json";
import DownloadEndpointFiles from "../../locales/fr/help/DownloadEndpointFiles.json";
import epmvdos from "../../locales/fr/help/Epmvdos.json";
import epmvmcp from "../../locales/fr/help/Epmvmcp.json";
import epmvpd from "../../locales/fr/help/epmvpd.json";
import eppromptDoc from "../../locales/fr/help/EppromptDoc.json";
import Epsdos from "../../locales/fr/help/Epsdos.json";
import Epsmcp from "../../locales/fr/help/Epsmcp.json";
import GetAllEndpoints from "../../locales/fr/help/GetAllEndpoints.json";
import getAllTests from "../../locales/fr/help/getAllTests.json";
import getEndpointById from "../../locales/fr/help/getEndpointById.json";
import GetEndpointDetails from "../../locales/fr/help/GetEndpointDetails.json";
import GetTestStatusById from "../../locales/fr/help/GetTestStatusById.json";
import HaCreateProfile from "../../locales/fr/help/HaCreateProfile.json";
import HaDeleteProfile from "../../locales/fr/help/HaDeleteProfile.json";
import HaGetAllProfiles from "../../locales/fr/help/HaGetAllProfiles.json";
import HaGetAllTestFiles from "../../locales/fr/help/HaGetAllTestFiles.json";
import HaGetProfileById from "../../locales/fr/help/HaGetProfileById.json";
import HaGetRecommendations from "../../locales/fr/help/HaGetRecommendations.json";
import HaGetReportById from "../../locales/fr/help/HaGetReportById.json";
import HaGetSessionKey from "../../locales/fr/help/HaGetSessionKey.json";
import HaProfileConfig from "../../locales/fr/help/HaProfileConfig.json";
import HaProfileConfigAISspecific from "../../locales/fr/help/HaProfileConfigAISspecific.json";
import HaProfileConfigMCP from "../../locales/fr/help/HaProfileConfigMCP.json";
import HaProfileConfigPDocs from "../../locales/fr/help/HaProfileConfigPDocs.json";
import HaProfileConfigReg from "../../locales/fr/help/HaProfileConfigReg.json";
import HaProfileConfigRTO from "../../locales/fr/help/HaProfileConfigRTO.json";
import Hconsolidated from "../../locales/fr/help/Hconsolidated.json";
import helpAddUsers from "../../locales/fr/help/HelpAddUsers.json";
import HelpAiEndpoint from "../../locales/fr/help/HelpAiEndpoint.json";
import HelpCenter from "../../locales/fr/help/HelpCenter.json";
import helpCreatePromptsDocs from "../../locales/fr/help/HelpCreatePromptsDocs.json";
import Helpcus from "../../locales/fr/help/Helpcus.json";
import helpDos from "../../locales/fr/help/helpDos.json"; // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
import Helpdosinput from "../../locales/fr/help/Helpdosinput.json";
import Helpgl from "../../locales/fr/help/Helpgl.json";
import helpIns from "../../locales/fr/help/helpIns.json";
import helpmcp from "../../locales/fr/help/helpmcp.json";
import helpmcpinput from "../../locales/fr/help/helpmcpinput.json";
import helpmodelattack from "../../locales/fr/help/helpmodelattack.json";
import HelpProfile from "../../locales/fr/help/HelpProfile.json";
import helprginput from "../../locales/fr/help/helprginput.json";
import helprgprofile from "../../locales/fr/help/helprgprofile.json";
import helprto from "../../locales/fr/help/helprto.json";
import helprtoinput from "../../locales/fr/help/helprtoinput.json";
import HelpSubscreenTemplate from "../../locales/fr/help/HelpSubscreenTemplate.json";
import ListAllEndpointConfigurations from "../../locales/fr/help/ListAllEndpointConfigurations.json";
import Llmapi from "../../locales/fr/help/Llmapi.json";
import Llmprofile from "../../locales/fr/help/Llmprofile.json";
import RunTest from "../../locales/fr/help/RunTest.json";
import StopTest from "../../locales/fr/help/StopTest.json";
import UpdateEndpoint from "../../locales/fr/help/UpdateEndpoint.json";
import helpScan from "../../locales/fr/help/helpScan.json";
import Whlic from "../../locales/fr/help/Whlic.json";
import thelp from "../../locales/fr/help/thelp.json";
import epvmcp from "../../locales/fr/help/epvmcp.json";
import helpgh from "../../locales/fr/help/helpgh.json";

import eprc from "../../locales/fr/help/eprc.json";
import eprto from "../../locales/fr/help/eprto.json";
import epvdos from "../../locales/fr/help/epvdos.json";
import Helppdf from "../../locales/fr/help/Helppdf.json";
import epvpd from "../../locales/fr/help/epvpd.json";
import HelpHarness from "../../locales/fr/help/HelpHarness.json";











// ... import more french help json files here

const frHelp = {
  loginAndSignup,
  HelpHarness,
  epvpd,
  Helppdf,
  epvdos,
  eprto,
  eprc,
  helpScan,
  howToStart,
  createEndpoint,
  createProfile,
  aiEndpointOverview,
  configureAIEndpoint,
  testAIEndpoint,
  helpRgp,
  helpPrompt,
  helpPromptInput,
  AISimulatorGuide,
  CreateEndpointUsingJsonParams,
  CreateEndpointUsingScripts,
  CreateEp,
  DeleteEndpoint,
  DownloadEndpointFiles,
  epmvdos,
  epmvmcp,
  epmvpd,
  eppromptDoc,
  Epsdos,
  Epsmcp,
  GetAllEndpoints,
  getAllTests,
  getEndpointById,
  GetEndpointDetails,
  GetTestStatusById,
  HaCreateProfile,
  HaDeleteProfile,
  HaGetAllProfiles,
  HaGetAllTestFiles,
  HaGetProfileById,
  HaGetRecommendations,
  HaGetReportById,
  HaGetSessionKey,
  HaProfileConfig,
  HaProfileConfigAISspecific,
  HaProfileConfigMCP,
  HaProfileConfigPDocs,
  HaProfileConfigReg,
  HaProfileConfigRTO,
  Hconsolidated,
  helpAddUsers,
  HelpAiEndpoint,
  HelpCenter,
  helpCreatePromptsDocs,  
  Helpcus,
  helpDos, // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
  Helpdosinput,
  Helpgl,
  helpIns,
  helpmcp,
  helpmcpinput,
  helpmodelattack,
  HelpProfile,
  helprginput,
  helprgprofile,
  helprto,
  helprtoinput,
  HelpSubscreenTemplate,
  ListAllEndpointConfigurations,
  Llmapi,
  Llmprofile,
  RunTest,
  StopTest,
  UpdateEndpoint,
  Whlic,
 thelp,
 epvmcp,
 helpgh

  // add more french help jsons here
};

export default frHelp;
